// [CASH-MODE] Payment modes shown and filtered across all reports.
// Backend contract: send `paymentMode` = 'UPI' | 'CASH' | 'ALL' (ALL or missing = no filter).
// Every transaction row returned by the API carries `paymentMode` ('UPI' when the row predates cash).

export const PAYMENT_MODES = Object.freeze({
  ALL: 'ALL',
  UPI: 'UPI',
  CASH: 'CASH',
});

export const PAYMENT_MODE_OPTIONS = [
  { value: PAYMENT_MODES.ALL, label: 'All (UPI + Cash)' },
  { value: PAYMENT_MODES.UPI, label: 'UPI' },
  { value: PAYMENT_MODES.CASH, label: 'Cash' },
];
